import { gql } from '@apollo/client';

export const QUERY = gql`
  query RegistrationFormAdjustments($formId: Int!) {
    registrationFormAdjustments(formId: $formId) {
      amount
      answerToMatch
      formFieldId
      formId
      id
      maxAmount
      maxQuantity
      percentage
      appliesTo
      couponCode
      enabled
      startDate
      endDate
      qualifyingCount
      qualifyingOperator
      formAdjustmentDefinition {
        active
        amount
        category
        id
        maxAmount
        name
        type
      }
    }
  }
`;
